import React, { Component } from 'react';
import './App.css';
import GileadeMap from './GileadeMap'
import IconButton from 'material-ui/IconButton'
import MenuIcon from 'material-ui-icons/Menu';
import { withStyles } from 'material-ui/styles'
import GileadeDrawer from './GileadeDrawer'
import Hidden from 'material-ui/Hidden';
import createStore from '../Redux/createStore'
import {Provider} from 'react-redux'
import AppActions from '../Redux/appRedux'
import {compose} from 'recompose'

const styles = theme => ({
  appFrame: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.background.default
  },
  content: {
    padding: 20,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      height: 'calc(100% - 64px)',
    },
  }
})

class App extends Component {
  state = {
    mobileOpen: false,
    store: createStore()
  }

  toggleDrawer = () => this.setState({mobileOpen: !this.state.mobileOpen})

  componentDidMount() {
    this.state.store.dispatch(AppActions.startup())
  }

  render() {
    const {classes} = this.props
    return (
      <Provider store={this.state.store}>
        <div className={classes.appFrame}>
          <GileadeDrawer
            isMobileOpen={this.state.mobileOpen}
            toggleDrawer={this.toggleDrawer}/>
          <main className={classes.content}>
            <Hidden mdUp >
              <IconButton onClick={this.toggleDrawer} aria-label="menu">
                <MenuIcon />
              </IconButton>
            </Hidden>
            <GileadeMap />
          </main>
        </div>
      </Provider>
    );
  }
}


export default compose(
  withStyles(styles, { withTheme: true })
)(App)



// WEBPACK FOOTER //
// ./src/Components/App.js